import { useRef } from 'react';

/**
 * Returns a ref that always holds the latest value.
 * Useful for callbacks that need to read current state without being recreated.
 * 
 * @example
 * const latestValue = useLatest(value);
 * // later in a callback:
 * const current = latestValue.current;
 */
export function useLatest<T>(value: T) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}